import refreshCaptcha from "../utils/captcha-refresh";

document.addEventListener('DOMContentLoaded', ()=> {
    main();
    refreshCaptcha('.pp-captcha__code-refresh', '.pp-captcha__code-img');
});
jQuery(document).on('gform_post_render', function(){
    main();
    refreshCaptcha('.pp-captcha__code-refresh', '.pp-captcha__code-img');
});

function main() {
    jQuery('#input_9_18').inputmask({
        mask: '',
        regex: "^[0-9]{0,100}$",
        showMaskOnHover: false,
        showMaskOnFocus: false,
    });

    jQuery('#input_9_7').inputmask({
        mask: '',
        regex: "^[0-9]{2,100}$",
        showMaskOnHover: false,
        showMaskOnFocus: false,
    });

    jQuery('#input_9_1').inputmask({
        mask: '',
        regex: "^[a-zA-ZęóąśłżźćńĘÓĄŚŁŻŹĆŃ -]+$",
        showMaskOnHover: false,
        showMaskOnFocus: false,
    });

    jQuery('#input_9_3').inputmask({
        mask: '',
        regex: "^[a-zA-ZęóąśłżźćńĘÓĄŚŁŻŹĆŃ -]+$",
        showMaskOnHover: false,
        showMaskOnFocus: false,
    });

    if(null!=document.querySelector('#input_9_24')){

        document.querySelector('#input_9_24').addEventListener('input', (e) => {
            hideCorrespondingInput(e.target.value);
        });
        document.querySelector('#input_9_24').addEventListener('change', (e) => {
            hideCorrespondingInput(e.target.value);
        });

        hideCorrespondingInput();

    }



}

function hideCorrespondingInput(value) {
    value = value ? value : document.querySelector('#input_9_24').value;
    if(/^\s*$/.test(value)) {
        document.querySelector('#field_9_25').setAttribute('data-conditional-logic', 'hidden');
        document.querySelector('#field_9_25').style.display = 'none';
    }else {
        document.querySelector('#field_9_25').setAttribute('data-conditional-logic', 'visible');
        document.querySelector('#field_9_25').style.display = 'block';
    }
}